"use client";

import * as React from "react";
import {
  AudioWaveform,
  BookOpen,
  Bot,
  Command,
  Frame,
  GalleryVerticalEnd,
  Map,
  PieChart,
  Settings2,
  SquareTerminal,
  Users,
  History,
} from "lucide-react";

import { NavMain } from "@/components/nav-main";
import { NavProjects } from "@/components/nav-projects";
import { NavUser } from "@/components/nav-user";
import { TeamSwitcher } from "@/components/team-switcher";
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader, SidebarRail } from "@/components/ui/sidebar";
import { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { usePocket } from "@/contexts/PocketContext";

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const data = useMemo(
    () => ({
      user: {
        name: "shadcn",
        email: "m@example.com",
        avatar: "/avatars/shadcn.jpg",
      },
      teams: [],
      navMain: [
        {
          title: "Операторы",
          url: "/operators",
          icon: SquareTerminal,
          isActive: true,
          items: [
            {
              title: "Все операторы",
              url: "/operators",
            },
            {
              title: "Добавить оператора",
              url: "/operators/add",
            },
            {
              title: "Отчеты",
              url: "/operators/reports",
            },
          ],
        },
        {
          title: "Бригады",
          url: "/teams",
          icon: Users,
          isActive: true,
          items: [
            {
              title: "Все бригады",
              url: "/teams",
            },
            {
              title: "Добавить бригаду",
              url: "/teams/add",
            },
          ],
        },
        {
          title: "Заявки",
          url: "/applications",
          icon: Bot,
          isActive: true,
          items: [
            {
              title: "Все заявки",
              url: "/applications",
            },
            {
              title: "История изменений",
              url: "/applications/events",
              icon: History,
            },
          ],
        },
        {
          title: "Отчёты",
          url: "/reports",
          icon: BookOpen,
          isActive: true,
          items: [
            {
              title: "По заявкам",
              url: "/reports",
            },
			{
              title: "По источникам",
              url: "/reports/sources",
            },
			
          ],
        },
      ],
      projects: [
        {
          name: "Design Engineering",
          url: "#",
          icon: Frame,
        },
        {
          name: "Sales & Marketing",
          url: "#",
          icon: PieChart,
        },
        {
          name: "Travel",
          url: "#",
          icon: Map,
        },
      ],
    }),
    [],
  );

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <TeamSwitcher />
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} />
        {/*<NavProjects projects={data.projects} />*/}
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
